import {getParamFromUrl} from '../index';

export const applyDefaultState = {
  step: 0,
  type: 'DEFAULT',
  job: { //Current Job for which the apply is called.Only required Fields added
    id: '',
    title: '',
    snbUrl: '/jobs',
    cityId: ''
  },
  disableInputs: false,
  directApplyAdId: null, // used to initiate apply from amp
  refDirectApplyAdId: null, // used to pass source in apply request
  applySource: null,
  discount: 0,
  showCallUnlockBuyOptions: false,
  applyForm: {},
  hasNewStepTwoAnswers: false,
  isSkipApplyInitiated: false,
  isQuickApplyInitiated: false,
  utmSource: '',
  utmMedium: '',
  utmCampaign: ''
};



// WEBPACK FOOTER //
// ../q-jobs/src/utils/Apply/defaultState.js